<template>
    <nio-button-group class="text-gray-600">
        <nio-button class="w-10" :disabled="currentPage == 1" @click="goTo(1)">
            <nio-icon name="regular/arrow-button-left-1" />
        </nio-button>
        <nio-button class="w-10" :disabled="currentPage == 1" @click="goTo(currentPage - 1)">
            <nio-icon name="regular/arrow-left-1" />
        </nio-button>
        <nio-button
            class="w-11"
            :color="page == currentPage ? 'blue' : 'white'"
            :key="page"
            @click="goTo(page)"
            v-for="page in visiblePages"
        >
            {{ page }}
        </nio-button>
        <nio-button class="w-10" :disabled="currentPage == lastPage" @click="goTo(currentPage + 1)">
            <nio-icon name="regular/arrow-right-1" />
        </nio-button>
        <nio-button class="w-10" :disabled="currentPage == lastPage" @click="goTo(lastPage)">
            <nio-icon name="regular/arrow-button-right-1" />
        </nio-button>
    </nio-button-group>
</template>

<script>
    import range from 'lodash/range.js';

    export default {
        props: {
            currentPage: {
                type: Number,
                required: true,
            },
            lastPage: {
                type: Number,
                required: true,
            },
        },

        computed: {
            visiblePages() {
                const pages = range(1, this.lastPage + 1);

                return pages.filter(page => {
                    if (this.currentPage == 1) {
                        return page <= this.currentPage + 2;
                    } if (this.currentPage == this.lastPage) {
                        return page >= this.currentPage - 2;
                    }

                    return page <= this.currentPage + 1 && page >= this.currentPage - 1;
                });
            },
        },

        methods: {
            goTo(page) {
                if (
                    page < 1 ||
                    page > this.lastPage ||
                    (this.currentPage == 1 && page == 1) ||
                    (this.currentPage == this.lastPage && page == this.lastPage)
                ) {
                    return;
                }

                this.$emit('update', page);
            },
        },
    };
</script>
